import { useSyncExternalStore } from 'react';
import { UI_GLASS } from './shared';
import { hasNativePlugin, isNative } from '@/lib/native/is-native';

/**
 * Re-read when AuthedShell paints `data-ui` or `data-ui-native` on <html>
 * (see ./shared.ts), so the answer follows without a reload.
 */
function subscribe(onChange: () => void): () => void {
  const observer = new MutationObserver(onChange);
  observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-ui', 'data-ui-native'] });
  return () => observer.disconnect();
}

const isGlass = () => document.documentElement.dataset.ui === UI_GLASS;

const isGlassNative = () =>
  isGlass() &&
  document.documentElement.dataset.uiNative === '1' &&
  isNative() &&
  hasNativePlugin('MuckaGlassBar');

/**
 * The native glass bar (PR 4, docs/liquid-glass-native-bar-plan.md): the
 * signed-in app, `accounts.ui_glass_native` on, AND an app build that has the
 * plugin. Any one missing and the web glass bar stays, so an old binary or a
 * browser can never be left with no bar at all.
 */
export function useUiGlassNative(): boolean {
  return useSyncExternalStore(subscribe, isGlassNative, () => false);
}
